<template>
  <div class="content">
    <PulseLoader
      :loading="!loaded"
      :class="{ hide: loaded }"
      quote="Action is the foundational key to all success"
      author="Pablo Picasso"
      profession="Spanish Painter"
      img="picasso.jpg"
    ></PulseLoader>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <div class="md-layout">
          <div class="md-layout-item p-0">
            <nav aria-label="breadcrumb" role="navigation">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: defaultScreen }"> Home</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Benchmarking Tool
                </li>
              </ol>
            </nav>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <!-- <pulse-loader
                      :color="'blue'"
                      :loading="!loaded"
                    ></pulse-loader> -->
                    <md-card class="welcome-card-wrap m-0" v-if="loaded">
                      <div class="md-layout-item">
                        <div class="md-card-content p-0">
                          <div class="flex_content">
                            <h1 class="section_header p-0 m-0">
                              Select a Report Format
                            </h1>
                            <ProgressBar :scale="progress" />
                          </div>
                        </div>
                      </div>
                      <div class="md-layout mt-4 report_format">
                        <div
                          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
                          v-for="card in cards"
                          :key="card.id"
                        >
                          <div
                            class="md-card-header md-card-header-icon md-card-header-blue new-report-body m-0"
                          >
                            <div
                              class="new-profile-image-container new-report-box"
                            >
                              <div class="img_wpr">
                                <img :src="/img/ + card.img" />
                              </div>
                              <h5 class="">{{ card.title }}</h5>
                              <div class="image-toolbar new-report-icons">
                                <a class="toolbar-left text-left">
                                  <i
                                    class="md-icon md-icon-font md-theme-default"
                                    >info</i
                                  >
                                  <div class="card_info">
                                    <div class="info_header">
                                      {{ card.title }}
                                    </div>
                                    <div class="info_body">
                                      <p>
                                        Pellentesque habitant morbi tristique
                                        senectus et netus et malesuada fames ac
                                        turpis egestas. Donec vestibulum sit
                                        amet felis sit amet accumsan. Sed odio
                                        lacus, varius vel augue vitae, pretium
                                        porta est.
                                      </p>
                                    </div>
                                  </div>
                                </a>
                                <!-- <div class="toolbar-right text-right">
                                  <md-icon
                                    :key="'tab' + card.id + key"
                                    class="clickable"
                                    @click.native="
                                      favoriteTool(
                                        `${card.name}`,
                                        `${card.title}`,
                                        `${card.link}`
                                      )
                                    "
                                    :style="
                                      isFavorite(`${card.name}`)
                                        ? 'color: blue'
                                        : ''
                                    "
                                  >
                                    {{
                                      isFavorite(`${card.name}`)
                                        ? 'star'
                                        : 'star_border'
                                    }}
                                  </md-icon>
                                </div> -->
                              </div>
                            </div>
                            <md-card-actions class="button-new-report">
                              <!-- <router-link
                                :to="{
                                  name: card.to,
                                  params: { id: 32523623 },
                                }"
                              > -->
                              <md-button
                                class="md-button-content md-info button"
                                @click="openNewReport(card)"
                              >
                                <md-icon class="">check</md-icon>Select
                              </md-button>
                              <!-- </router-link> -->
                            </md-card-actions>
                          </div>
                        </div>
                      </div>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProfileCard, PulseLoader, ProgressBar } from '@/components';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { mapState } from 'vuex';

export default {
  components: { PulseLoader, ProgressBar },
  data() {
    return {
      key: 0,
      progress: 40,
      cards: [
        {
          id: 0,
          name: 'financial-report-favourite',
          title: 'Financial Report',
          img: 'image_placeholder.jpg',
          to: 'NewProfile',
          type: 'if',
        },
        {
          id: 1,
          name: 'market-report-favourite',
          title: 'Market Report',
          img: 'image_placeholder.jpg',
          to: 'NewMarketProfile',
          type: 'imr',
        },
        {
          id: 2,
          name: 'vestimate-report-favourite',
          title: 'Valuation Report',
          img: 'image_placeholder.jpg',
          to: 'NewValuationReport',
          type: 'vpro',
        },
        {
          id: 3,
          name: 'company-report-favourite',
          title: 'Company Report',
          img: 'image_placeholder.jpg',
          to: 'NewCompanyReport',
          type: 'swot',
        },
      ],
      myData: null,
      years: null,
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
  methods: {
    isFavorite(name) {
      if (localStorage.getItem(name) === null) {
        return false;
      } else {
        return true;
      }
    },
    favoriteTool(name, title, link) {
      if (this.isFavorite(name)) {
        localStorage.removeItem(name);
        this.key += 1;
        this.$store.commit('INCREMENT_REFRESH_KEY');
      } else {
        localStorage.setItem(name, `${title}`);
        this.key += 1;
        this.$store.commit('INCREMENT_REFRESH_KEY');
      }
    },
    getMyData: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.$route.query['data-id'];
      this.loaded = false;

      let params = {
        session_id: currentSession,
        my_data_id: myDataId,
      };

      await this.$store.dispatch('myData/get', params).then((res) => {
        this.myData = res.data.my_data;
        this.years = res.data.years;
        this.loaded = true;
      });
    },
    openNewReport: async function(card) {
      if (card.to === 'VRBusinessValue') {
      } else {
        this.$router.push({
          name: card.to,
          query: { 'data-id': this.$route.query['data-id'] },
        });
        this.progress = 50;
      }
    },
    clearAll: async function() {
      this.industry = null;
      this.marketArea = null;
      this.salesClass = null;
      this.$store.commit('SET_PROFILE_ID', null);
      this.$store.commit('M_SET_PROFILE_ID', null);
      this.$store.commit('SET_INDUSTRY', null);
      this.$store.commit('SET_MARKET_AREA', null);
      this.$store.commit('SET_SALES_CLASS', null);
    },
  },
  async created() {
    await this.clearAll();
    await this.getMyData();
  },
};
</script>

<style lang="scss">
.new-report-body {
  position: relative;
  .button-new-report {
    display: none;
    position: absolute;
    top: 16%;
    border-top: none !important;
    justify-content: center;
    .md-ripple {
      padding: 5px 10px 5px 20px !important;
    }
  }

  &:hover {
    .button-new-report {
      display: block !important;
    }
  }

  .new-report-box {
    position: relative;

    h5 {
      margin-top: 15px;
    }
    .new-report-icons {
      display: flex;
      justify-content: space-between;
      width: 100%;
      position: absolute;
      top: 0;
    }
  }
}
</style>
